export const pricingModes = {
  monthly: {
    plans: [
      { title: "Solo", price: "$10 per month" },
      { title: "Pro", price: "$19 per month" },
      { title: "Elite", price: "$39 per month" },
      { title: "Ultimate", price: "$99 per month" },
    ],
  },
  yearly: {
    plans: [
      { title: "Solo", price: "$8.33 per month", sub: "$100 annually" },
      { title: "Pro", price: "$15.83 per month", sub: "$190 annually" },
      { title: "Elite", price: "$32.50 per month", sub: "$390 annually" },
      { title: "Ultimate", price: "$82.50 per month", sub: "$990 annually" },
    ],
  },
};

export const features = [
  { name: "Projects / Domains", values: [7, 25, 50, 300] },
  { name: "Tracked Keywords", values: [400, 1250, 4500, 10000] },
  { name: "Rank Updates", values: ["Daily", "Daily", "Daily", "Daily"] },
  { name: "Competitors / Domain", values: [4, 10, 15, 20] },
  {
    name: "Locations",
    values: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
  },
  { name: "Users", values: [1, 2, 6, 10] },
  {
    name: "Domain Overview",
    values: ["150/month", "400/month", "600/month", "1000/month"],
  },
  {
    name: "Pages Crawl",
    values: ["1000/weekly", "2000/weekly", "5000/weekly", "12000/weekly"],
  },
  {
    name: "Keyword Research",
    values: ["50/month", "100/month", "400/month", "1000/month"],
  },
  {
    name: "Backlink Rows",
    values: ["10000/month", "15000/month", "25000/month", "50000/month"],
  },
  {
    name: "AI Writer",
    values: ["5 blogs", "10 blogs", "20 blogs", "30 blogs"],
  },
  { name: "White Label Reports", values: [false, false, false, true] },
  { name: "Local Map Tracking", values: [false, false, true, true] },
  { name: "White Label Platform", values: [false, false, false, true] },
  {
    name: "AI Overview Tracker",
    values: ["+$12", "+$12", "10 keywords", "50 keywords"],
  },
];
